import Cookies from "universal-cookie";

const cookies = new Cookies();
const BASE = process.env.BACKOFFICE_SERVER_URL || "";

const clientError = ({ status, code, message, retryable = false }) => ({
  status, code, message, retryable,
});

const configuredUrl = (path) => {
  if (!BASE) throw clientError({ status: 0, code: "configuration_error", message: "Backoffice não configurado." });
  try {
    const base = new URL(BASE);
    if (!["http:", "https:"].includes(base.protocol) || base.username || base.password) throw new Error();
    const basePath = base.pathname.replace(/\/+$/, "");
    const url = new URL(`${basePath}/${path}`, `${base.origin}/`);
    if (url.origin !== base.origin) throw new Error();
    return url;
  } catch (error) {
    if (error?.code === "configuration_error") throw error;
    throw clientError({ status: 0, code: "configuration_error", message: "Backoffice não configurado." });
  }
};

const governanceFetch = async (path, { method = "GET", body } = {}) => {
  const url = configuredUrl(path);
  const { token } = cookies.get("userId") || {};
  if (typeof token !== "string" || !token) {
    throw clientError({ status: 401, code: "authentication_required", message: "Faça login novamente." });
  }
  let response;
  try {
    response = await fetch(url.toString(), {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body ? { "Content-Type": "application/json" } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw clientError({ status: 0, code: "network_error", message: "Não foi possível comunicar com o servidor.", retryable: true });
  }
  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw clientError({
      status: response.status,
      code: typeof data?.errorCode === "string" ? data.errorCode : "request_failed",
      message: typeof data?.message === "string" ? data.message : "Não foi possível concluir a operação.",
      retryable: data?.retryable === true || response.status >= 500,
    });
  }
  return data;
};

const segment = (value) => encodeURIComponent(String(value));

export const fetchGovernancePortfolio = (companyId) => (
  governanceFetch(`governance/companies/${segment(companyId)}/portfolio`)
);
export const updateGovernancePortfolio = (companyId, mutation) => (
  governanceFetch(`governance/companies/${segment(companyId)}/portfolio`, { method: "PUT", body: mutation })
);
export const discoverGovernancePortfolio = (companyId) => (
  governanceFetch(`governance/companies/${segment(companyId)}/discover`)
);
export const fetchOpeningBalances = (companyId) => (
  governanceFetch(`governance/companies/${segment(companyId)}/opening-balances`)
);
export const createOpeningBalance = (companyId, mutation) => (
  governanceFetch(`governance/companies/${segment(companyId)}/opening-balances`, { method: "POST", body: mutation })
);
export const fetchGovernanceAudit = (companyId) => {
  const query = new URLSearchParams({ company_id: String(companyId) });
  return governanceFetch(`governance/audit?${query}`);
};
export const listResourceMatches = (companyId, { projectKey, status = "candidate" } = {}) => {
  const query = new URLSearchParams({
    project_id: String(projectKey),
    status: String(status),
  });
  return governanceFetch(`governance/companies/${segment(companyId)}/resource-matches?${query}`);
};
export const decideResourceMatch = (companyId, candidateId, mutation) => (
  governanceFetch(`governance/companies/${segment(companyId)}/resource-matches/${segment(candidateId)}/decision`, {
    method: "POST",
    body: mutation,
  })
);

export default {
  fetchGovernancePortfolio,
  updateGovernancePortfolio,
  discoverGovernancePortfolio,
  fetchOpeningBalances,
  createOpeningBalance,
  fetchGovernanceAudit,
  listResourceMatches,
  decideResourceMatch,
};
